import { ForumRemoveIcon } from './ForumRemoveIcon';

/**
 * author: Michael Irigoyen
 * id E7013FF6-E962-4ED4-BCA9-5BE12DF03146
 * name forum-remove
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/forum-remove.svg
 * tags
 */
export const ChatDeleteIcon = ForumRemoveIcon;
export default ChatDeleteIcon